import { post, fetch, Del, put } from "@/ask/axios";
import alertSuccess from '@/components/userCenter/public/alertSuccess.vue'
import bus from '@/ask/eventBus';
export default {
  name: 'notice',
  inject: ['reload'],
  components: { alertSuccess },
  data() {
    return {
      api: {
        url: "",
        param: "",
        response: {},
        message: ""
      },
      NoticeInfo: [],
      MenuList: [],
      businessType: 1,
      activeName: '1',
      activeTab: '1',
      success: false,
      isLoading: true,
      EmailAll: false,
      foldNum: [],//折叠的下标
      CustomerOwnerType: null

    };
  },
  created() {
    this.userTopInfo(); //用户信息
    this.getNotice()
    this.getUserMenu()

    // 获取用户菜单
  },
  methods: {

    getMainTitle(titleNo) {
      let stateTexts = []
      switch (this.businessType) {
        case 1:
          stateTexts = ['Notify me with tracking No.', 'Warehouse receipt', 'Departured', 'Delivered', "Track update"]
          break;
        case 3:
          stateTexts = ['Entry warehouse', 'Booking successful', 'Out of warehouse', 'Released customs', 'Departured', 'In transit', 'Arrival airport', 'Finish customs clearance', 'In the delivery', 'Delivered', 'Picked Up']
          break;
        case 7:
          stateTexts = ['Driver to pick up', 'Goods delivered', 'Termination of pick up']
          break;
        case 10:
          stateTexts = ['Price promotion notice']
          break;
      }
      let state = titleNo - 1
      return stateTexts[state]
    },
    changTab() {
      this.businessType = Number(this.activeName)
      this.getNotice()
      this.isLoading = true
    },
    // 获取用户Notice信息
    getNotice() {
      // this.api.url = this.$api02 + "/api/EbayCustomer/NoticeSettingEn/GetNoticeSetting";
      // this.api.url = this.$api04 + "/Basics/api/NoticeSettingCnController/GetNoticeSettingEn";
      this.api.url = this.$api04 + "/Basics/api/NoticeSettingCn/GetNoticeSettingEn";
      this.api.param = {
        businessType: this.businessType
      }
      var reqDate = new Date().getTime()
      fetch(this.api.url, this.api.param).then(res => {
        if (res.IsOK) {
          this.dealRes(res.Results, reqDate)
        }
      });
    },
    // 获取用户Notice信息
    getUserMenu() {
      this.api.url = this.$api02 + "/api/EbayCustomer/Menu/GetMenuEn";
      this.api.param = {
      }
      post(this.api.url, this.api.param).then(res => {
        if (res.IsOK) {

          if (res.Results) {
            let ChildMenu = res.Results[0].ChildMenu;
            ChildMenu.forEach(ele => {
              if (this.CustomerOwnerType == 2 && ele.ID == 1002) {
                ele.IsShow = false
              }
            });
          }

          this.MenuList = res.Results
          this.sumbitMenu(1);
          //console.log("-----=====",this.MenuList);

        }
      });
    },
    //用户信息
    userTopInfo() {
      // this.api.url = this.$api02 + '/api/CustomerInfo/GetCustomerInfoByToken';
      this.api.url = this.$api04 + "/Basics/api/CustomerInfo/GetCustomerInfoByToken";
      this.api.param = {}
      post(this.api.url, this.api.param).then((res) => {
        //用户信息对象
        sessionStorage.setItem("SalesInfos", JSON.stringify(res.Results));
        if (res.Results) {
          this.CustomerOwnerType = res.Results.CustomerOwnerType;
        }
      })
    },
    // 全选和全不选
    isCheckAll(val) {
      let set = `${val}Sel`
      let data = `${val}All`
      if (this[data]) {
        this.NoticeInfo.forEach(item => {
          item[set] = true
        })
      } else {
        this.NoticeInfo.forEach(item => {
          item[set] = false
        })
      }
    },
    // 菜单的全显示
    isShowAll(item) {
      if (item.IsShow) {
        item.ChildMenu.forEach(ele => {
          ele.IsShow = true
        });
      } else {
        item.ChildMenu.forEach(ele => {
          if (ele.MenuUrl != '/myInfo/notice') {
            ele.IsShow = false
          }
        });
      }
    },
    isKnowCheck(index) {
      let flag = false
      this.MenuList[index].ChildMenu.forEach(ele => {
        if (ele.IsShow) {
          flag = true
        }
      });
      this.MenuList[index].IsShow = flag
    },
    // 展开和折叠
    fold(index) {
      if (!this.foldNum.length) {
        this.foldNum.push(index)
        return
      }
      for (let i = 0; i < this.foldNum.length; i++) {
        if (this.foldNum[i] == index) {
          this.foldNum.splice(i, 1)
          return
        }
      }
      this.foldNum.push(index)
    },
    //当前状态是否时全选
    knowIsCheck() {
      let EmailAll = true
      for (let i = 0; i < this.NoticeInfo.length; i++) {
        const ele = this.NoticeInfo[i]
        if (!ele.EmailSel) {
          EmailAll = false
        }
      }
      this.EmailAll = EmailAll
    },
    postNotice() {
      // this.api.url = this.$api02 + "/api/EbayCustomer/NoticeSettingCn/UpdateNoticeSetting";
      // this.api.url = this.$api02 + "/Basics/api/NoticeSettingCnController/UpdateNoticeSetting";
      this.api.url = this.$api04 + "/Basics/api/NoticeSettingCn/UpdateNoticeSetting";
      let NoticeSettingList = []
      for (let i = 0; i < this.NoticeInfo.length; i++) {
        var EmailValue = -1
        var MobileValue = -1
        if (this.NoticeInfo[i].IsEmail) {
          this.NoticeInfo[i].EmailSel ? EmailValue = 1 : EmailValue = 0
        }
        if (this.NoticeInfo[i].IsMobile) {
          this.NoticeInfo[i].MobileSel ? MobileValue = 1 : MobileValue = 0
        }
        NoticeSettingList.push(
          {
            Id: this.NoticeInfo[i].t_CST_CustomerNoticeSettingId,
            EmailValue: EmailValue,
            MobileValue: MobileValue
          }
        )
      }
      this.api.param = {
        NoticeSettingList: NoticeSettingList
      }
      post(this.api.url, this.api.param).then(res => {
        if (res.IsOK) {
          this.alert()
        } else {
          // this.alert('保存失败')
        }
      });
    },
    sumbitMenu(index) {
      this.api.url = this.$api02 + "/api/EbayCustomer/Menu/UpdateMenuEn";
      let showMenuList = []
      for (let i = 0; i < this.MenuList.length; i++) {
        const ele = this.MenuList[i]
        if (ele.ID != 1 && ele.IsShow) {
          showMenuList.push({
            MenuID: ele.ID,
            MenuCode: ele.MenuCode,
            MenuName: ele.MenuName,
          })
          // 如果主菜单是不显示  那后面的也无需添加
          for (let j = 0; j < ele.ChildMenu.length; j++) {
            const elj = ele.ChildMenu[j];
            if (elj.IsShow) {
              showMenuList.push({
                MenuID: elj.ID,
                MenuCode: elj.MenuCode,
                MenuName: elj.MenuName,
              })
            }
          }
        }
      }
      this.api.param = {
        MenuEnList: showMenuList
      }
      post(this.api.url, this.api.param).then(res => {
        if (res.IsOK) {
          if (index == 2) {
            this.alert(true)
          }
          //重载 
        } else {
          // this.alert('保存失败')
        }
      });
    },
    // 处理返回的数据
    dealRes(Arr, reqDate) {
      if (this.businessType == 1) {
        // 先写死 以后再说
        Arr[3] = Arr.splice(4, 1, Arr[3])[0];
      }
      for (let i = 0; i < Arr.length; i++) {
        Arr[i].MobileValue ? Arr[i].MobileSel = true : Arr[i].MobileSel = false
        Arr[i].EmailValue ? Arr[i].EmailSel = true : Arr[i].EmailSel = false
      }
      this.NoticeInfo = Arr
      this.knowIsCheck()
      // 请求大于1s 就不等 小于1s 凑1s
      var getDate = new Date().getTime()
      let time = 1000
      if (getDate - reqDate < 1000) {
        time = 1000 - (getDate - reqDate)
        setTimeout(() => {
          this.isLoading = false
        }, time)
      } else {
        this.isLoading = false
      }
    },
    alert(reload) {
      this.success = true
      if (reload) {
        bus.$emit('reGetMenuInfo') //重新加载菜单
      }
      setTimeout(() => {
        this.success = false
        this.isLoading = true
        this.getNotice()
        // this.refresh()
      }, 2000)
    },
    // refresh () {
    //   this.reload()
    // },
  }
}




// WEBPACK FOOTER //
// ./src/assets/js/userCenter/myInfo/notice.js